import {IErrors} from "@/model/IErrors";
import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/RootState";
import responseHandler from "@/plugins/errorHandling";
import axios from "axios";
import {settings} from "@/plugins/settings";
import {ILaLigaCompetition} from "@/model/LaLiga/ILaLigaCompetition";


interface LaLigaState {
  laLigaCompetitions: ILaLigaCompetition[];
  // logs: ILockerLog[]; // we might need this later to show the logs
  errors: IErrors;
}

const state: LaLigaState = {
  laLigaCompetitions: [],
  // logs: [],
  errors: {},
};

const getters: GetterTree<LaLigaState, RootState> = {
  competitions: (state: LaLigaState): ILaLigaCompetition[] => state.laLigaCompetitions,
  // logs: (state): ILockerCompanyLog[] => state.logs,
  errors: (state) => state.errors,
}

const actions: ActionTree<LaLigaState, RootState> = {

  fetchCompetitions: ({ commit }, lockerId: number): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'lockers/' + lockerId + '/laLigaCompetitions',
      method: "GET",
    }),
    commit,
    'laLigaCompetitionsLoaded'
  ),

  // clearCompetitions: ({commit}):any => commit('clearCompetitions'),

  createCompetition: ({ commit }, {lockerId, startAt, endAt}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'lockers/' + lockerId + '/laLigaCompetitions',
      method: "POST",
      data: {
        start_at: startAt,
        end_at: endAt
      },
    }),
    commit,
    'laLigaCompetitionsLoaded',
    'lockers.locker.laLiga.errors'
  ),

  // fetchLogs: ({commit}: any, filters: any): any => responseHandler.handle(
  //   () => axios({
  //     url: `${settings.endpoint}lockerCompanies/logs`,
  //     method: 'GET',
  //     params: {
  //       ...filters,
  //     },
  //   }),
  //   commit,
  //   'lockerCompanyLogsLoaded'
  // ),

  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  },

  cleanErrors: ({commit}): any => {
    commit('errors', []);
  }

}

const mutations: MutationTree<LaLigaState> = {

  laLigaCompetitionsLoaded(state: LaLigaState, payload: ILaLigaCompetition[]) {
    state.laLigaCompetitions = payload;
  },

  clearCompetitions(state: LaLigaState) {
    state.laLigaCompetitions = [];
  },

  errors(state, payload: IErrors) {
    state.errors = payload;
  },

}

const namespaced: boolean = true;

export const laLigaModule: Module<LaLigaState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
